const { createContext, useState, useEffect } = require("react");
import { event_view_item } from "@/utils/gtm";
import store from "store";

const CompareContext = createContext({
  compareProducts: [],
  showCompareFooter: false,
  setShowCompareFooter: () => {},
  addProductToCompare: () => {},
  removeProductFromCompare: () => {},
  clearCompare: () => {},
});

export const CompareProvider = ({ children }) => {
  const [compareProducts, setCompareProducts] = useState(
    store.get("compare_products") || []
  );

  useEffect(() => {
    store.set("compare_products", compareProducts);
  }, [compareProducts]);

  const [showCompareFooter, setShowCompareFooter] = useState(
    store.get("show_compare_footer") || false
  );

  useEffect(() => {
    store.set("show_compare_footer", showCompareFooter);
  }, [showCompareFooter]);

  const addProductToCompare = (product) => {
    const existingProduct = compareProducts.find(
      (compareProduct) => compareProduct.sku === product.sku
    );
    setCompareProducts((prev) => {
      if (existingProduct) {
        event_view_item(product, "remove_from_compare");
        return prev.filter((item) => item.sku !== product.sku);
      } else {
        event_view_item(product, "add_to_compare");
        return [...prev, product];
      }
    });
  };

  const removeProductFromCompare = (product) => {
    setCompareProducts((prev) => {
      event_view_item(product, "remove_from_compare");
      return prev.filter(
        (compareProduct) => compareProduct.sku !== product.sku
      );
    });
  };

  const clearCompare = () => {
    setCompareProducts([]);
  };
  return (
    <CompareContext.Provider
      value={{
        compareProducts,
        addProductToCompare,
        removeProductFromCompare,
        clearCompare,
        showCompareFooter,
        setShowCompareFooter,
      }}
    >
      {children}
    </CompareContext.Provider>
  );
};

export default CompareContext;
